import Animals from "../../../components/AnimalPageComponents/Animal_card/animals_card"
import style from './styleanimals.module.css'
import React, { useContext } from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import NavBar from "../../../components/Layout/NavBar/NavBar"
import AnimalsPaginate from "../../../components/AnimalPageComponents/AnimalsPaginate";
import Footer from "../../../components/Layout/Footer/index";
import { ModalContext, ModalProvider } from "src/context/ModalContext";
import axios from "axios";
import {Spinner} from "react-bootstrap";

const INITIAL_DATA = {
    total: 0,
    current_page: 1,
    last_page: 1,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    prev_page_url: null,
    path: "",
    from: 1,
    to: 1,
    data: [],
  };
  
export default function AnimalsPage(){

  let [searchParams, setSearchParams] = useSearchParams();
  let controller = new AbortController();

  const INITIAL_FILTERS = {
    search: searchParams.get("search") || "",
    species: [],
    size: [],
    phase: [],
    is_castrated: [],
    special_animal: [],
    is_pinned: [],
  };

  const INITIAL_QUERY = {
      sort: "id",
      order: "desc",
      per_page: 15,
      page: searchParams.get("page") || 1,
  };

  const [isLoading, setLoading] = React.useState(true);
  const [isLoadingAnimal, setLoadingAnimal] = React.useState(true);
  const [isFiltering, setFiltering] = React.useState(true);
  const [isPaginating, setPaginating] = React.useState(true);

  const [query, setQuery] = React.useState({
      ...INITIAL_QUERY,
      ...INITIAL_FILTERS,
  });
  const [filters, setFilters] = React.useState({ ...INITIAL_FILTERS });
  const [animalData, setAnimalData] = React.useState({ ...INITIAL_DATA });
  const [informationData, setInformationData] = React.useState({ ...INITIAL_DATA });
    const [phone, setPhone] = React.useState("");


    let endpoints  = [
    "information",
        'whatsApp'
  ]

  const requestData = (args = {}) => {
      setLoading(true);
    axios.all(endpoints.map((endpoint) => BaseApi.get(endpoint))).then((response) => {
      setInformationData(response[0].data);
      setPhone(response[1].data);
    })
        .then((response) => {
          setLoading(false);
        })
        .catch((err) => {
          if (err) {
              setLoading(false)
            toast.error("Erro ao carregar dados da tabela");
            setInformationData({ ...INITIAL_DATA })
              setPhone("")
          }
        });
  };

  const requestDataAnimal = (args = {}) => {
      setLoadingAnimal(true);
    let q = { ...query, ...args };
    BaseApi.get("/animais_naoadotados", {
      signal: controller.signal,
      params: {
        ...q,
        search: q.search !== "" ? q.search : undefined,
        per_page: 15,
      },
    })
        .then((response) => {
          setAnimalData(response.data);
          setLoadingAnimal(false);
          setPaginating(false);
          setFiltering(false);
        })
        .catch((err) => {
          if (err) {
            toast.error("Erro ao carregar dados da tabela");
            setAnimalData({ ...INITIAL_DATA });
            setLoading(false);
            setPaginating(false);
            setFiltering(false);
          }
        });
  };

  const handlePagination = (page) => {
    setSearch({ p: page });
    setPaginating(true);
    setQuery({ ...query, page });
  };

  const setSearch = (args = {}) => {
    let params = { ...args };
    if (filters.search && filters.search !== "") params.q = filters.search;
    setSearchParams(params);
  };


  const handleSelectAnimals = (e, type) => {
    let data = [...query[type]];
    let {value, checked} = e.target;

    if(checked) {
      data.push(value);
    } else {
      data = data.filter((item) => item !== value);
    }
    let copy = {...query, page:1};
    copy[type] = data;
    setQuery(copy);
  }

  const {isModal, toggleIsModal} = useContext(ModalContext)

  useEffect(() => {
    controller = new AbortController();
    requestData();
    requestDataAnimal();
    
    return () => {
    controller.abort();
    setLoading(true);
    };
  }, [query]);

  return(
    <>

        <NavBar
        phone={phone}/>

      <div className={style.animalspage}>
        <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.3.0/css/all.min.css"
        integrity="sha512-SzlrxWUlpfuzQ+pcUCosxcglQRNAq/DZjVsC0lE40xsADsfeQoEypE+enwcOiGjk/bSuGGKHEyjSoQ1zVisanQ=="
        crossorigin="anonymous" referrerpolicy="no-referrer" />
        <text className={style.texth1}>CONHEÇA NOSSOS ANIMAIS</text>
        <div className={style.btnGroup}>
          <input type="checkbox" className="w-auto btn-check" id="cat" value="cat" onChange={(e) => handleSelectAnimals(e, 'species')} onClick={(e) => e.stopPropagation()}></input>
          <label for="cat">Gato</label>
          
          <input type="checkbox" className="w-auto btn-check" id="dog" value="dog" onChange={(e) => handleSelectAnimals(e, 'species')} onClick={(e) => e.stopPropagation()}></input>
          <label for="dog">Cachorro</label>
          
          <input type="checkbox" className="w-auto btn-check" id="cub" value={'cub'} onChange={(e) => handleSelectAnimals(e, 'phase')} onClick={(e) => e.stopPropagation()}></input>
          <label for="cub">Filhote</label>
          
          <input type="checkbox" className="w-auto btn-check" id="adult" value={'adult'} onChange={(e) => handleSelectAnimals(e, 'phase')} onClick={(e) => e.stopPropagation()}></input>
          <label for="adult">Adulto</label>
          
          <input type="checkbox" className="w-auto btn-check" id="elderly" value={'elderly'} onChange={(e) => handleSelectAnimals(e, 'phase')} onClick={(e) => e.stopPropagation()}></input>
          <label for="elderly">Idoso</label>
          
          <input type="checkbox" className="w-auto btn-check" id="small" value={'small'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="small">Porte pequeno</label>
          
          <input type="checkbox" className="w-auto btn-check" id="medium" value={'medium'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="medium">Porte médio</label>
          
          <input type="checkbox" className="w-auto btn-check" id="large" value={'large'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="large">Porte grande</label>
          
          <input type="checkbox" className="w-auto btn-check" id="undefined" value={'undefined'} onChange={(e) => handleSelectAnimals(e, 'size')} onClick={(e) => e.stopPropagation()}></input>
          <label for="undefined">Porte indefinido</label>
          
          <input type="checkbox" className="w-auto btn-check" id="castrated" value={'1'} onChange={(e) => handleSelectAnimals(e, 'is_castrated')}></input>
          <label for="castrated">Castrado</label>
          
          <input type="checkbox" className="w-auto btn-check" id="not-castrated" value={'0'} onChange={(e) => handleSelectAnimals(e, 'is_castrated')}></input>
          <label for="not-castrated">Não castrado</label>
          
          <input type="checkbox" className="w-auto btn-check" id="special" value={'1'} onChange={(e) => handleSelectAnimals(e, 'special_animal')}></input>
          <label for="special">Especial</label>
        </div>
          {(isLoadingAnimal || isPaginating ) && (
              <>
                  <Spinner animation="border" role="status" className={style.spinner}>
                      <span className="visually-hidden">Loading...</span>
                  </Spinner>
              </>
          )}
        {!isLoadingAnimal && (
            <AnimalsPaginate
                className={style.pagination}
                onPaginate={handlePagination}
                showOnBottom={!isPaginating && animalData.data.length > 0}
                showOnTop={animalData.data.length > 0}
                paginateData={animalData}
                isFiltering={isFiltering}
            >
                {isFiltering && (
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                )}
              {!isPaginating && (
                  <div className={style.wrapper}>
                    {animalData.data.map ((animals) => (
                        <>
                          <Animals
                              animalId={animals.id}
                              img={animals.animal_img}
                              name={animals.name}
                              sex={animals.sex}
                          />
                        </>
                    ))}
                  </div>
              )}
              {isPaginating && (
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
              )}
              {(animalData.data.length == 0 && !isLoadingAnimal) && (
                <div className={style.notFound}>
                  <h5 className="text-purple-3 text-center">
                    Não foram encontrados registros com estes filtros.
                  </h5>
                </div>
              )}
            </AnimalsPaginate>
        )}
      </div>

      {(informationData && !isLoading && !isLoadingAnimal)&&(
          <Footer
              informationData={informationData}
              phone={phone}/>
      )}
    </>
  )
}